import PageTitle from '../PageTitle';
import { Link } from 'react-router-dom';
import config from './../data/config.json';
import Slider from 'react-slick';
import { useEffect, useRef, useState } from 'react';
import SectionTestimonials from '../Section.Testimonials';
import {Helmet} from 'react-helmet'
const Services = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  // State to track the tallest card
  const [tallestCardHeight, setTallestCardHeight] = useState<number>(0);

  // Track the tallest card height on mount and when the window resizes
  useEffect(() => {
    const updateTallestCardHeight = () => {
      if (window.innerWidth < 768) {
        // On mobile, skip the height equalization
        setTallestCardHeight(0);
        return;
      }

      const cardElements = document.querySelectorAll('.card');
      let maxHeight = 0;

      cardElements.forEach((card: any) => {
        const cardHeight = card.offsetHeight;
        if (cardHeight > maxHeight) {
          maxHeight = cardHeight;
        }
      });

      setTallestCardHeight(maxHeight);
    };

    updateTallestCardHeight();

    window.addEventListener('resize', updateTallestCardHeight);
    return () => window.removeEventListener('resize', updateTallestCardHeight);
  }, [config.services]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    afterChange: (index: number) => setCurrentSlide(index),
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, arrows: true },
      },
    ],
  };

  const sliderRef = useRef<any>(null);
  return (
    <>
      <Helmet>
        <title>I'm Your Huckleberry | Services</title>

      </Helmet>
      <div className="bg-light-blue py-5">
        <div className="text-black">
          <PageTitle title="Our Cleaning Services" backgroundColor="transparent" textColor="black">
            <p className="text-center col-12 col-md-8 mx-auto text-black">
              Our cleaning business is equipped to handle all your residential and commercial
              cleaning needs, including construction cleanup, move-in/move-out cleaning, and deep
              cleaning services. We are dedicated to delivering thorough, professional results
              tailored to your specific requirements, ensuring exactly what you want every time.
            </p>
          </PageTitle>
        </div>

        <div className="container mt-4">
          <div className="row g-4">
            <div className="slider-wrapper position-relative">
              <Slider ref={sliderRef} {...settings}>
                {config.services.map((service, index) => (
                  <div key={index} className="p-3 slide-item">
                    <div
                      className="card shadow-sm border-0 rounded-4"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: tallestCardHeight ? `${tallestCardHeight}px` : 'auto',
                      }}
                    >
                      <img
                        src={service.img}
                        alt={service.title}
                        className="card-img-top rounded-top-4"
                        style={{ objectFit: 'cover', height: '200px' }}
                      />
                      <div className="card-body d-flex flex-column" style={{ flexGrow: 1 }}>
                        <h5 className="card-title">{service.title}</h5>
                        <p className="card-text small">{service.description}</p>
                        <Link
                          to={service.url}
                          className="btn btn-green mt-3 align-self-start w-100"
                        >
                          Learn More
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <SectionTestimonials />
    </>
  );
};

export default Services;
